import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function UniqueMechanism() {
  return <section className="bg-navy-dark py-20 md:py-28 text-white relative overflow-hidden" data-id="element-156">
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold-accent opacity-10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-157"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-159">
          <MapPin className="w-16 h-16 text-gold-accent mx-auto mb-6" data-id="element-160" />
          <h2 className="text-4xl md:text-5xl font-bold uppercase mb-6" data-id="element-161">
            El Mapa de{' '}
            <span className="text-gold-accent" data-id="element-162">Conexión Directa</span>
          </h2>
          <p className="text-xl md:text-2xl font-body text-gray-300 mb-8 leading-relaxed" data-id="element-163">
            Dentro de la Guía de Libertad Fiscal, obtendrás este sistema de
            navegación paso a paso hacia los portales federales y estatales que,
            por ley, deben ser gratuitos.
          </p>
          <p className="text-lg text-gray-400 font-body mb-10" data-id="element-164">
            Te mostramos cómo eliminar al preparador y las actualizaciones de
            software costosas yendo directamente a las plataformas del IRS que
            no te piden tarjeta de crédito.
          </p>
          <CTAButton href="#oferta" data-id="element-165">OBTEN TU GUIA AHORA</CTAButton>
        </motion.div>
      </div>
    </section>;
}